export function OperationalPlaceholder({ label, className = "", compact = false }) {
  return <figure className={`operational-placeholder ${compact ? "compact" : ""} ${className}`} role="img" aria-label={label}>
    <span className="corner corner-a"/><span className="corner corner-b"/><span className="corner corner-c"/><span className="corner corner-d"/>
    <div className="placeholder-visual" aria-hidden="true"><span/><span/><span/></div>
  </figure>;
}

export function OperationalImage({ src, alt, caption, className = "", eager = false }) {
  return <figure className={`operational-image ${className}`.trim()}>
    <picture>
      <source srcSet={`/images/${src}.webp`} type="image/webp" />
      <img src={`/images/${src}.jpg`} alt={alt} width="1600" height="900" loading={eager ? "eager" : "lazy"} fetchPriority={eager ? "high" : "auto"} decoding="async" />
    </picture>
    {caption && <figcaption>{caption}</figcaption>}
  </figure>;
}
